export default __webpack_public_path__ + "static/media/carouselImage4.bccf6cb8.jpg";